<script>
import appConfig from "@/app.config";
import Km from "../../../components/document/cancellation-contracts/km.vue"
import { propertycancelationService } from "../../../services/propertyservice/propertycancelation.service";
/* eslint-disable no-console */
/**
 * Invoice-detail component
 */

export default {
  page: {
    title: "Cancellation Contract",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { 
    Km
  },
  data() {
    return {
      title: "Cancellation Contract",
      items: [
        {
          text: "Invoices",
          href: "/",
        },
        {
          text: "Detail",
          active: true,
        },
      ],

      contract: null,
      template: 3,
      
    };
  },
  mounted() {
    // loading data
    this.loadingData(this.$route.params.id);     
    
  },
  methods: {
    
     
    loadingData: function(id) {

      this.fetchingStats = false;
      propertycancelationService.getPropertyCancellationContract(id)
        .then(response => {
          this.fetchingStats = true;
          this.contract = response.data;
        //   this.template = this.contract.template_id;

          // console.log(this.contract);
        });
        
    }


  },
};
</script>

<template>


  <Km :data="contract" />
</template>